import React from 'react';
import {VerifyUser} from '../../../components/give-recco/verify-user';
import {Account, AccountAuthDetails} from '../../../models';
import {ScreenState} from '../../../types';

type OtpGateProps = {
  account: Account | null;
  errorMessage: string;
  screenState: ScreenState;
  onAccountChange: (account: Account | null) => void;
  onErrorChange: (message: string) => void;
  onStateChange: (state: ScreenState) => void;
  onVerified: (value: {account: Account; auth: AccountAuthDetails}) => void;
};

export const PublicProfileOtpGate: React.FC<OtpGateProps> = ({
  account,
  errorMessage,
  onAccountChange,
  onErrorChange,
  onStateChange,
  onVerified,
  screenState,
}) => {
  return (
    <div className="min-h-screen bg-gray-50 px-4 py-12">
      <div className="mx-auto w-full max-w-2xl rounded-3xl border border-gray-100 bg-white/80 p-8 shadow-lg shadow-blue-50">
        <VerifyUser
          account={account}
          containerClassName="rounded-3xl border border-gray-50 bg-white p-8 shadow-md"
          descriptionText="Enter your number to receive a one-time code."
          displayError={errorMessage}
          headingText="Verify to view this Aura"
          showNameField={false}
          onVerified={onVerified}
          phoneLabel="Mobile number"
          sendOtpText="Send code"
          setAccount={onAccountChange}
          setDisplayError={onErrorChange}
          setState={onStateChange}
          state={screenState}
          verifyButtonText="Unlock profile"
        />
      </div>
    </div>
  );
};
